import { ErrorResponse } from "@/hooks/types";
import {
  AssetDto,
  AssetWithRelatedMetadataDto,
  UpdateAssetDto,
  UploadWithAssetsDto,
  UploadWithAssetsDtoStateEnum,
} from "generated";

export type Actions = {
  initializeMetadata: (assets: UploadWithAssetsDto, assetIds?: string) => void;
  setActiveAsset: (assetId: number) => void;
  toggleAssetCheckbox: (assetId: number) => void;
  toggleSetAllCheckbox: (checked: boolean) => void;
  updateAssetMetadataSuccessful: (updates: UpdateAssetDto[]) => void;
  setMetadataError: (error: ErrorResponse) => void;
  setLoading: () => void;
  setComment: (comment: string) => void;
  validationRequested: () => void;
  setValidationError: (errors: ValidationEntry[]) => void;
  clearPlaceholderErrors: () => void;
  removeAsset: (assetId: number) => void;
};

export type AssetState = AssetWithRelatedMetadataDto & {
  isActive: boolean;
  isChecked: boolean;
};

export type AssetsChangeMap = Record<string, UpdateAssetDto>;

export type AssetValidationEntry = {
  assetId: number;
  field: keyof AssetDto | "placeholder";
  message: string;
};

export type UploadValidationEntry = {
  field: "upload";
  message: string;
};

export type ValidationEntry = AssetValidationEntry | UploadValidationEntry;

export const isAssetValidationEntry = (
  entry: ValidationEntry,
): entry is AssetValidationEntry => {
  return "assetId" in entry;
};

export type State = {
  status: "LOADING" | "ERROR" | "SUCCESS";
  uploadId?: number;
  uploadState: UploadWithAssetsDtoStateEnum;
  assets: AssetState[];
  error?: ErrorResponse;
  comment?: string;
  validationErrors: ValidationEntry[];
};

export type MetadataSlice = State & Actions;
